import { render, staticRenderFns } from "./OfficeLayout.vue?vue&type=template&id=bb5ff858&scoped=true&"
import script from "./OfficeLayout.vue?vue&type=script&lang=js&"
export * from "./OfficeLayout.vue?vue&type=script&lang=js&"
import style0 from "./OfficeLayout.vue?vue&type=style&index=0&id=bb5ff858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5ff858",
  null
  
)

export default component.exports